/* =========================================================================
   ScarClear — hero section behaviour
   Only one thing needs JS here: the mobile navigation drawer.
   Written as an IIFE with no globals so it can be dropped into a Shopify
   theme without colliding with anything else on the page.
   ========================================================================= */
(function () {
  'use strict';

  var burger = document.querySelector('.sc-burger');
  var nav    = document.querySelector('.sc-nav');
  var scrim  = document.querySelector('.sc-nav__scrim');

  if (!burger || !nav || !scrim) return;

  var isOpen = false;
  var lastFocused = null;

  function focusableInNav() {
    return nav.querySelectorAll('a[href], button:not([disabled])');
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;

    nav.classList.add('is-open');
    scrim.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close menu');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    var first = focusableInNav()[0];
    if (first) first.focus();
  }

  function close(returnFocus) {
    if (!isOpen) return;
    isOpen = false;

    nav.classList.remove('is-open');
    scrim.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    if (returnFocus) {
      (lastFocused && lastFocused.focus ? lastFocused : burger).focus();
    }
  }

  burger.addEventListener('click', function () {
    isOpen ? close(true) : open();
  });

  scrim.addEventListener('click', function () { close(true); });

  var closeBtn = nav.querySelector('.sc-nav__close');
  if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });

  /* close after tapping a link in the drawer */
  nav.addEventListener('click', function (e) {
    if (e.target.closest('.sc-nav__link')) close(false);
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;

    if (e.key === 'Escape') {
      close(true);
      return;
    }

    /* keep tab focus inside the drawer while it is open */
    if (e.key === 'Tab') {
      var items = focusableInNav();
      if (!items.length) return;
      var first = items[0];
      var last  = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* if the viewport grows back to desktop, drop the drawer state */
  var desktop = window.matchMedia('(min-width: 1024px)');
  var onChange = function (e) { if (e.matches) close(false); };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange);
  else if (desktop.addListener) desktop.addListener(onChange);
})();
